<template>
    <div class="list">
        <div class="consult_null" v-if="!isDownLoading && orderItems.length == 0" @click.stop="goConsult">订单问题咨询</div>
        <scroller style="{padding-top:0px;}" :on-refresh="refresh" :on-infinite="infinite" ref="my_scroller" :height="scrollHeight" :isShowDownLoading="isShowDownLoading">
            <div class="first-load" v-if="isFirstLoading">
                <img src="//file.40017.cn/touchweixinqq/weixin/public/img/loading.svg" />
            </div>
            <div v-if="orderItems.length > 0">
                <div v-for="(item, index) in orderItems" :key="item.SerialNo + item.OrderId + index">
                    <div class="cuttingLine" v-if="item.type && item.type == 'cuttingLine'">
                        <span class="cuttingtext">——&nbsp;&nbsp;&nbsp;以下是{{transformNum(pageSetting.NormalMonths)}}个月前的订单哦&nbsp;&nbsp;&nbsp;——</span>
                    </div>
                    <orderItem 
                    :iteminfo="item"
                    :position="index" 
                    :actposition="actposition"
                    @closeMore="closeMore"
                    :itemindex="index"
                    :cancelReasonProjects="pageSetting.cancelReasonProjects"  class="orderItems"  @deleteItem="deleteItem" @cancelItem="cancelItem" v-else>
                    </orderItem>
                </div>
            </div>
            <div v-if="!isDownLoading && orderItems.length == 0" class="no-data-show-list">
                <div class="enpty-order" v-if="!requestError && orderItems.length == 0">
                    <img src="https://file.40017.cn/tcservice/wxapp/chat/image/indent_null.png">
                    <div v-if="getMonthsDes == 'gt' || !pageSetting.InForce || noThreeMonthOrder">
                        <p class="enpty-order-desc">暂无一年内的订单哟~</p>
                        <div v-if="isSingle == 0" @click="backTo" class="toIndexHome" :href="indexHome">
                            <div>返回</div>
                        </div>
                    </div>
                    <div v-else>
                        <p style="margin-bottom: 70px;">暂无{{transformNum(pageSetting.NormalMonths)}}个月内的订单哟~</p>
                        <div class="gt-btn" @click="getGTOrder">查看{{transformNum(pageSetting.NormalMonths)}}个月前的订单</div>
                    </div>
                </div>
                <div v-if="requestError" class="request-error">
                    <img src="https://file.40017.cn/tcservice/wxapp/chat/image/data_error.png">
                    <p>额哦，暂未获取到您的订单<br />请稍后再试~</p>
                </div>
            </div>
            <template v-if="getMonthsDes == 'gt' || !pageSetting.InForce || noThreeMonthOrder">
                <div slot="bottom-tip" v-if="false && nowActive == 1002 || nowActive == 9">
                    <p>—— &nbsp;&nbsp;&nbsp;已显示最近三个月的订单，没有更多了~&nbsp;&nbsp;&nbsp;——</p>
                    <div class="consult" @click.stop="goConsult">订单问题咨询</div>
                </div>
                <div slot="bottom-tip"  class="consult-box" v-else> 
                    <p>—— &nbsp;&nbsp;&nbsp;已展示最近一年的订单，没有更多了呦~&nbsp;&nbsp;&nbsp;——</p>
                    <div class="consult" @click.stop="goConsult">订单问题咨询</div>
                </div>
            </template>
            <template v-else>
                <div class="gtBtn-box" slot="bottom-tip">
                    <div class="gt-btn" @click="getGTOrder">查看{{transformNum(pageSetting.NormalMonths)}}个月前的订单</div>
                    <div class="consult" @click.stop="goConsult">订单问题咨询</div>
                </div>
            </template>
        </scroller>
        <showmodel ref="showModallist"></showmodel>
        <cancelDialog ref="cancelDialoglist"></cancelDialog>
    </div>
</template>

<script>
    import scroller from '../components/scroller/components/Scroller.vue'
    import {
        getStrFromUrl,
        changeTitle,
        getCookie,
        addCookie
    } from '../util/tool.js'
    import axios from 'axios'
    import {
        order,
        canceldata,
        orderArray
    } from '../util/order.js'
    import orderItem from '../components/orderitem.vue'
    import showmodel from '../components/showmodel'
    import cancelDialog from '../components/cancel'
    import Bus from '../components/bus.js'
    import {
        api,
        devType,
        miniAppVer,
        enterType,
        miniOrderVer
    } from './../util/api.js'
    export default {
        name: 'list',
        components: {
            orderItem,
            scroller,
            showmodel,
            cancelDialog
        },
        data() {
            return {
                noThreeMonthOrder:false,
                nodata: '暂无订单呦，返回上一页看看吧~',
                isFirstLoading: true,
                isShowDownLoading: false,
                requestError: false,
                isDownLoading: false,
                getMonthsDes: 'leq',
                page: 0,
                orderItems: [],
                scrollHeight: document.documentElement.clientHeight + '',
                nowActive: '',
                scrollPosition: '',
                pageFull: 0,
                pageSec: 0,
                isFullNodata: false,
                isSecNodata: false,
                isreply: false,
                indexHome: 'https://wx.17u.cn/home/index.html',
                name: '',
                isSingle: 0,
                pageSetting: {
                    NormalMonths: 12,
                    NormalBeginDate: 0,
                    InForce: false
                },
                actposition: '-1'
            }
        },
        created() {
            //addCookie('WxUser','openid=oOCyauN1lMP21d4ttZGrQVaVA4sc&unionid=ohmdTtz6H-h0kGgzlYMai3z6noYU',1000000)
            // 重定向到新站点
            // 1.收集参数
            const query = this.$route.query;
            const params = this.$route.params
            // 携带参数跳转 https://wx.17u.cn/ordercenterfrontv2/projects?id=1002&name=%E7%81%AB%E8%BD%A6%E7%A5%A8
            const newSite = 'https://wx.17u.cn/ordercenterfrontv2/projects'
            const newUrl = `${newSite}?id=${params.type}&name=${query.productName||query.name||'其他订单'}&isSingle=${query.isSingle||0}`
            if (query.force != '1'){
                // 不是强制进入，重定向
                AppendTrack(category, action, label, `重定向到新站点：${newUrl}`)
                location.replace(newUrl)
            }
        },
        mounted() {
            const query = this.$route.query;
            if (query.force != '1') {
                // 不是强制进入，重定向，不走老订单
                return   
            }  
            if (this.nowActive === '') {
                this.nowActive = location.href.indexOf('?') > 0 ? location.href.substring(location.href.indexOf('list') + 5, location.href.indexOf('?', location.href.indexOf('list'))) :
                    location.href.substring(location.href.indexOf('list') + 5);
            }
            this.isSingle = getStrFromUrl(location.href, 'isSingle');
            Bus.$on('fromIndexToNow', (data) => {
                this.nowActive = data.type;
                this.getMonthsDes = 'leq'
                this.nodata = `暂无${data.name}订单呦，返回上一页看看吧~`
                this.name = data.name;
                axios.get(api.GetPageSetting, {params: {
                    "miniAppVer": miniAppVer,
                    "cts": new Date().getTime(),
                    "devType": devType,
                    'enterType': enterType
                }}).then(res => {                    
                    if(res.data && res.data.Body) {
                        let pagsetting={}
                        if (res.data.Body.PageSettingMap) {
                            pagsetting = res.data.Body.PageSettingMap[0]
                        }    
                        this.pageSetting = Object.assign(this.pageSetting, {                            
                            NormalMonths: pagsetting.NormalMonths || (res.data.Body.NormalMonths || 12),
                            NormalBeginDate: pagsetting.NormalBeginDate|| (res.data.Body.NormalBeginDate || 0),
                            cancelReasonProjects:res.data.Body.CancelReasonProjects
                        })

                        if(this.pageSetting.NormalMonths == 12) {
                            this.pageSetting.InForce = false
                        } else {
                            this.pageSetting.InForce = true
                        }
                    }
                    this.init();
                }).catch(err => {
                    this.init();
                })
            })
            //请求过滤的列表
            let wxuser = getCookie('WxUser');
            let params = {
                openId: this.spliteWxUser(wxuser, 'openid'),
                unionid: this.spliteWxUser(wxuser, 'unionid')
            }
            if (this.isSingle == 1) {
                this.name = decodeURIComponent(getStrFromUrl(location.href, 'productName'))
                changeTitle(this.name || '其他订单')
            } else {
                this.name = decodeURIComponent(getStrFromUrl(location.href, 'name'))
                changeTitle(this.name || '其他订单')                
            }
            axios.get(api.GetPageSetting, {params: {
                "miniAppVer": miniAppVer,
                "cts": new Date().getTime(),
                "devType": devType,
                'enterType': enterType
            }}).then(res => {
                if(res.data && res.data.Body) {                    
                    let pagsetting={}
                    if (res.data.Body.PageSettingMap) {
                        pagsetting = res.data.Body.PageSettingMap[0]
                    } 
                    this.pageSetting = Object.assign(this.pageSetting, {                            
                        NormalMonths: pagsetting.NormalMonths || (res.data.Body.NormalMonths || 12),
                        NormalBeginDate: pagsetting.NormalBeginDate|| (res.data.Body.NormalBeginDate || 0),
                        cancelReasonProjects:res.data.Body.CancelReasonProjects
                    })
                    // this.pageSetting = Object.assign(this.pageSetting, {
                    //     NormalBeginDate: res.data.Body.NormalBeginDate || 0,
                    //     NormalMonths: res.data.Body.NormalMonths || 12,
                    //     cancelReasonProjects:res.data.Body.CancelReasonProjects
                    // })

                    if(this.pageSetting.NormalMonths == 12) {
                        this.pageSetting.InForce = false
                    } else {
                        this.pageSetting.InForce = true
                    }
                }
                this.init();
            }).catch(err => {
                this.init();
            })
        },
        watch: {
            // $route(to,from){
            //     if(from.path.indexOf('list') >= 0 && to.path.indexOf('classifylist') >= 0){
            //         debugger
            //         Bus.$emit('hidedialog',{});
            //         Bus.$emit('hideCanceldialog',{});
            //         changeTitle('分类订单查询')
            //     }
            // }
        },
        methods: {
            spliteWxUser: function(rStr, str) {
                try {
                    let a = rStr.split("&");
                    for (let i in a)
                        if (a[i].indexOf(str + "=") >= 0) {
                            let n = a[i].split("=");
                            if (null != n[1])
                                return n[1]
                        }
                    return ""
                } catch (e) {}
                return ''
            },
            init() {                
                this.isFirstLoading = true;
                this.isShowDownLoading = false;
                this.requestError = false;
                this.isDownLoading = false;
                this.noThreeMonthOrder=false;
                this.page = 0;
                this.orderItems = [];
                this.scrollPosition = '';
                this.pageFull = 0;
                this.pageSec = 0;
                this.isFullNodata = false;
                this.isSecNodata = false;
                this.isreply = false;
                Bus.$emit('hidedialog', {});
                Bus.$emit('hideCanceldialog', {});                 
                if (!this.isreply) {
                    this.getFirstData()
                } else {
                }
                this.nodata = `暂无${this.name}订单呦，返回上一页看看吧~`
            },
            backTo: function() {
                this.actposition = '-1'
                this.$router.go(-1);
                changeTitle("分类查找订单")
            },
            refresh: function(done, isShowToast) {                
                this.actposition = '-1'
                let me = this,
                    mynowActive = me.nowActive;
                me.getMonthsDes = 'leq'
                me.pageFull = 1;
                let requestdata = {
                    "miniAppVer": miniAppVer,
                    "cts": new Date().getTime(),
                    "devType": devType,
                    "productId": me.nowActive,
                    "pagei": me.pageFull,
                    "count": 10,
                    "orderFilter": 0,
                    'enterType': enterType,
                    'ordVer':miniOrderVer,
                }
                                   
                if (me.noThreeMonthOrder){
                    requestdata = Object.assign(requestdata, {
                        "normalMonths": 12,
                        "normalBeginDate": me.pageSetting.NormalBeginDate,
                        "getMonthsDes": me.getMonthsDes
                    })
                }else{
                        requestdata = Object.assign(requestdata, {
                        "normalMonths": me.pageSetting.NormalMonths,
                        "normalBeginDate": me.pageSetting.NormalBeginDate,
                        "getMonthsDes": me.getMonthsDes
                    })
                }
                
                if (me.isSingle == 1) {
                    requestdata.isSingle = 1
                }
                
                axios.post(api.GetFullOrders, requestdata, {
                    timeout: 5000
                }).then((response) => {
                    me.requestError = false;
                    let dataTemp = JSON.parse(response.data).Body
                    if (me.isFirstLoading) {
                        me.isFirstLoading = false;
                    }
                    if (dataTemp && dataTemp.length && dataTemp.length > 0) {
                        me.orderItems = dataTemp.splice(0);
                        setTimeout(() => {
                            if (typeof done === 'function') {
                                done()
                            } else {
                                me.$refs.my_scroller.finishPullToRefresh();
                            }
                        }, 100)
                    } else {
                        me.orderItems = [];
                        if (typeof done === 'function') {
                            done(true)
                        } else {
                            me.$refs.my_scroller.finishPullToRefresh(true);
                        }
                    }
                    if (me.orderItems.length == 0) {
                        me.isShowDownLoading = false;
                        me.isDownLoading = false;
                    } else {
                        me.isShowDownLoading = true;
                    }
                    if (!isShowToast) {
                        me.$toast("更新成功", 'center', 1000)
                    }
                }, (reject) => {
                    if (typeof done === 'function') {
                        done(true)
                    } else {
                        me.$refs.my_scroller.finishInfinite(true);
                    }
                    if (me.orderItems.length == 0) {
                        me.isShowDownLoading = false;
                        me.isDownLoading = false;
                        me.requestError = true;
                    } else {
                        me.isShowDownLoading = true;
                    }
                    if (!isShowToast) {
                        me.$toast("更新失败，请重试", 'center', 1000)
                    }
                }).catch(function(error) {
                    console.log(error);
                })
                AppendTrack(category, action, label, '^下拉刷新^');
            },
            infinite: function(done) {                
                if (!this.isFirstLoading) {
                    let me = this;
                    let mynowActive = me.nowActive;
                    if (me.orderItems.length == 0) {
                        me.isDownLoading = false;
                    } else {
                        me.isDownLoading = true;
                    }
                    me.pageFull += 1;
                    let requestdata = {
                        "miniAppVer": miniAppVer,
                        "cts": new Date().getTime(),
                        "devType": devType,
                        "productId": me.nowActive,
                        "pagei": me.pageFull,
                        "count": 10,
                        "orderFilter": 0,
                        'enterType': enterType,
                        'ordVer':miniOrderVer,
                    }
                                          
                    if(me.noThreeMonthOrder && me.getMonthsDes == 'leq'){
                        requestdata = Object.assign(requestdata, {
                            "normalMonths": 12,
                            "normalBeginDate": me.pageSetting.NormalBeginDate,
                            "getMonthsDes": me.getMonthsDes
                        })
                    }else{
                        requestdata = Object.assign(requestdata, {
                            "normalMonths": me.pageSetting.NormalMonths,
                            "normalBeginDate": me.pageSetting.NormalBeginDate,
                            "getMonthsDes": me.getMonthsDes
                        })
                    }
                    
                    if (me.isSingle == 1) {
                        requestdata.isSingle = 1
                    }
                    axios.post(api.GetFullOrders, requestdata).then((response) => {
                        me.requestError = false;                        
                        let dataTemp = JSON.parse(response.data).Body;
                        if (me.isFirstLoading) {
                            me.isFirstLoading = false;
                        }
                        if (dataTemp && dataTemp.length && dataTemp.length > 0) {
                            me.orderItems = me.orderItems.concat(dataTemp);
                            if (typeof done === 'function') {
                                done()
                            } else {
                                me.$refs.my_scroller.finishInfinite();
                            }
                        } else {
                            if(me.getMonthsDes == 'leq' && me.pageSetting.InForce) {
                                AppendTrack(category, action, label, `^更多订单曝光^查看${this.pageSetting.NormalMonths}个月前订单^`);
                            }
                            // if(typeof done  === 'function'){
                            //         done(true) 
                            // }else{
                            me.$refs.my_scroller.finishInfinite(true);
                            // }  
                        }
                        if (me.orderItems.length == 0) {
                            me.isShowDownLoading = false;
                            me.isDownLoading = false;
                        } else {
                            me.isShowDownLoading = true;
                        }
                    }, (reject) => {
                        this.pageFull -= 1;
                        if (typeof done === 'function') {
                            done(true)
                        } else {
                            me.$refs.my_scroller.finishInfinite(true);
                        }
                        if (me.orderItems.length == 0) {
                            me.isShowDownLoading = false;
                            me.isDownLoading = false;
                        } else {
                            me.isShowDownLoading = true;
                        }
                        if (me.isFirstLoading) {
                            me.isFirstLoading = false;
                        }
                    }).catch(function(error) {
                    })
                }
            },
            getFirstData(mynowActive) {                
                let me = this;
                me.isDownLoading = true;
                me.pageFull += 1;
                me.isreply = true;
                let requestdata = {
                    "miniAppVer": miniAppVer,
                    "cts": new Date().getTime(),
                    "devType": devType,
                    "productId": me.nowActive,
                    "pagei": me.pageFull,
                    "count": 10,
                    "orderFilter": 0,
                    'enterType': enterType,
                    'ordVer':miniOrderVer,
                }
                
                requestdata = Object.assign(requestdata, {
                    "normalMonths": me.pageSetting.NormalMonths,
                    "normalBeginDate": me.pageSetting.NormalBeginDate,
                    "getMonthsDes": me.getMonthsDes
                })
                
                if (me.isSingle == 1) {
                    requestdata.isSingle = 1
                }
                axios.post(api.GetFullOrders, requestdata).then((response) => {                    
                    this.requestError = false;
                    me.isreply = false;
                    let dataTemp = JSON.parse(response.data).Body;
                    if (me.isFirstLoading) {
                        me.isFirstLoading = false;
                    }
                    
                    if (dataTemp && dataTemp.length && dataTemp.length > 0) {
                        me.orderItems = [...me.orderItems, ...dataTemp];
                        me.$refs.my_scroller.finishInfinite();
                    } else {
                        if(me.getMonthsDes == 'leq' && me.pageSetting.InForce) {
                            AppendTrack(category, action, label, `^更多订单曝光^查看${this.pageSetting.NormalMonths}个月前订单^`);
                        }
                        me.$refs.my_scroller.finishInfinite(true);
                    }
                    if (me.orderItems.length == 0) {
                        me.isShowDownLoading = false;
                        me.isDownLoading = false;
                    } else {
                        me.isShowDownLoading = true;
                    }
                }, (reject) => {
                    me.isreply = false;
                    this.pageFull -= 1;
                    if (me.isFirstLoading) {
                        me.isFirstLoading = false;
                    }
                    if (me.orderItems.length == 0) {
                        me.isShowDownLoading = false;
                        me.isDownLoading = false;
                        this.requestError = true;
                    } else {
                        me.isShowDownLoading = true;
                    }
                }).catch(function(error) {
                })
            },
            deleteItem(data) {
                let serialNo = data.serialNo,
                    orderId = data.orderId,
                    productId = data.productId,
                    marking = serialNo || orderId;
                let arrayIndex = -1;
                for (let i = 0; i < this.orderItems.length; i++) {
                    let item = this.orderItems[i];
                    if (productId == item.ProductId && (item.SerialNo === marking || item.OrderId === marking)) {
                        arrayIndex = i;
                        break;
                    }
                }
                this.orderItems.splice(arrayIndex, 1);
                
                let END = this.orderItems[this.orderItems.length - 1]
                if(END && END.type && END.type == 'cuttingLine') {
                    this.orderItems.splice(this.orderItems.length - 1, 1)
                }
                
                if (this.orderItems.length == 0) {
                    this.isShowDownLoading = false;
                    this.isDownLoading = false;
                    this.nodata = this.nodata;
                }
            },
            cancelItem(data) {
                this.refresh(null, false);
            },
            transformNum(n) {
                let num = parseInt(n)
                let arr = ["零", "一", '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二']
                return arr[num]
            },
            getGTOrder() {
                this.actposition = '-1'
                let me = this; 
                if(me.orderItems.length == 0) {
                    me.isFirstLoading = true                    
                }
                //noThreeMonthOrder参数开始需求是在没有订单时才设置为true,后来需求调整为只有点击按钮后，都设置为true.所以现在改为直接设置为true
                me.noThreeMonthOrder = true
                AppendTrack(category, action, label, `^更多订单曝光^查看${this.pageSetting.NormalMonths}个月前订单^`)
                me.getMonthsDes = 'gt'
                me.$refs.my_scroller.showLoading = true;
                me.isDownLoading = true;
                me.pageFull = 1;
                me.isreply = true;
                let requestdata = {
                    "miniAppVer": miniAppVer,
                    "cts": new Date().getTime(),
                    "devType": devType,
                    "productId": me.nowActive,
                    "pagei": me.pageFull,
                    "count": 10,
                    "orderFilter": 0,
                    'enterType': enterType,
                    "normalMonths": me.pageSetting.NormalMonths,
                    "normalBeginDate": me.pageSetting.NormalBeginDate,
                    "getMonthsDes": me.getMonthsDes,
                    'ordVer':miniOrderVer,
                }
                if (me.isSingle == 1) {
                    requestdata.isSingle = 1
                }
                axios.post(api.GetFullOrders, requestdata).then((response) => {                    
                    this.requestError = false;
                    me.isreply = false;
                    let dataTemp = JSON.parse(response.data).Body;
                    if (me.isFirstLoading) {
                        me.isFirstLoading = false;
                    }
                    if (dataTemp && dataTemp.length && dataTemp.length > 0) {
                        let cuttingLine = {
                            type: 'cuttingLine'
                        }
                        dataTemp.unshift(cuttingLine)
                        me.orderItems = [...me.orderItems, ...dataTemp];
                        me.$refs.my_scroller.finishInfinite();
                    } else {
                        me.$refs.my_scroller.finishInfinite(true);
                    }
                    if (me.orderItems.length == 0) {
                        me.isShowDownLoading = false;
                        me.isDownLoading = false;
                    } else {
                        me.isShowDownLoading = true;
                    }
                }, (reject) => {
                    me.isreply = false;
                    this.pageFull -= 1;
                    if (me.isFirstLoading) {
                        me.isFirstLoading = false;
                    }
                    if (me.orderItems.length == 0) {
                        me.isShowDownLoading = false;
                        me.isDownLoading = false;
                        this.requestError = true;
                    } else {
                        me.isShowDownLoading = true;
                    }
                }).catch(function(error) {
                })
            },
            goConsult() {
                location.href = `https://wx.17u.cn/kefu/#/other?plat=wxordercenter`
                AppendTrack(category, action, label, `^订单问题咨询^`)
                this.actposition = '-1'
            },
            closeMore(data) {
               this.actposition = data.actposition
            }
        },
    }
</script>

<style scoped>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #333;
    }
    .list {
        text-align: center;
    }
    .orderItems {
        font-size: 0.24rem;
    }
    .enpty-order-desc {
        width: 60%;
        margin: auto;
        line-height: 0.5rem;
    }
    .no-data-show-list {
        width: 100%;
        box-sizing: border-box;
        padding-top: 2.6rem;
        padding: 0 auto;
        font-size: 0.32rem;
        color: #999;
        text-align: center;
    }
    .no-data-show-list img {
        width: 125px;
    }
    .first-load {
        width: 100%;
        margin: 4rem auto 0;
        text-align: center;
    }
    .first-load img {
        width: 0.6rem;
    }
    .toIndexHome {
        height: 30px;
        line-height: 30px;
        border-radius: 20px;
        width: 100px;
        display: inline-block;
        background: #fff;
        color: #333;
        text-decoration: none;
        display: -webkit-box;
        -webkit-box-pack: center;
        -webkit-box-align: center;
        -webkit-box-orient: vertical;
        text-align: center;
        margin: 20px auto;
    }
    .request-error {
        text-align: center;
        font-size: 0.32rem;
        line-height: 0.5rem;
    }
    .gt-btn {
        background: #fff;
        margin: 0 auto;
        width: 180px;
        height: 30px;
        line-height: 30px;
        display: -webkit-box;
        -webkit-box-align: center;
        -webkit-box-pack: center;
        border-radius: 30px;
        font-size: 14px;
        position: relative;
        color: #333;
        box-shadow: 0 0 0 1px rgba(153,153,153,0.3);
    }
    .gtBtn-box {
        padding: 20px 0 30px;
    }
    .consult-box{
        padding: 20px 0 30px;
    }
    .consult {
        font-size: 12px;
        color: #16b963;
        margin-top: 15px;
    }
    .consult_null {
        font-size: 12px;
        color: #16b963;
        position: fixed;
        z-index: 10;
        left: 50%;
        bottom: 40px;
        transform: translateX(-50%);
    }
    .load_more_warp {
        display: flex;
        align-items: center;
        justify-content: center;
    }
.cuttingLine {
	width: 100%;
	display: -webkit-box;
	-webkit-box-align: center;
	-webkit-box-pack: center;
    line-height: 0.26rem;
    padding-bottom: 0.2rem;
}
.cuttingtext {
    line-height: 0.26rem;
    font-size: 0.26rem;
    color: rgb(170, 170, 170);
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/page/list.vue